import React, { useContext, useState } from 'react';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
import CategoriesDropdown from '../live/CategoriesDropdown';
import { XRouterNavigateContext } from './seo/xrouter/XRouterNavigateContext';
import SportsDropdown from './SportsDropdown';
import OpenFavoritesButton from './OpenFavoritesButton';
import { useUserSettings } from './UserSettingsProvider';
import { getLabel } from '../data/labels';
import { getConfiguration } from '../data/utils/configuration';

export default function SportMenu(props) {
    const xrouterNavigateContext =  useContext(XRouterNavigateContext);
    const userSettings = useUserSettings();
    const [toggled, setToggled] = useState(false);

    function handleClick() {
        setToggled(!toggled)
    }

    const selectedSport = props.selected;
    const sportIcon = selectedSport == null ? null : iconSportCssClass(selectedSport.id, selectedSport.iconClass);
    const conf = getConfiguration()

    return (
        <div className="xs_sportMenu h-sports-navbar-height flex items-center px-2 h-10 bg-cc1">
            {(props.showBackButton || conf.iwh) &&
                <div className="flex items-center justify-center mr-1" onClick={() => xrouterNavigateContext.navigate(-1)}>
                    <i className="bi-arrow-left text-md text-cs1" />
                </div>
            }
            <div className="flex items-center justify-center xs-sport-icon-wrapper">
                {sportIcon &&
                    <div className={"xs-sport-icon inline-block w-[24px] h-[24px] " + sportIcon}></div>
                }
            </div>
            <div className="xs_sportMenu-sport flex items-center justify-start ml-1" onClick={handleClick}>
                <>
                    {selectedSport ?
                        <>
                            {props.showEventsCount && selectedSport.showEventsCount ?
                                <span className="text-md text-cs1">{selectedSport.descrizione || selectedSport.desc} ({selectedSport.eventsCount})</span>
                                :
                                <span className="text-md text-cs1">{selectedSport.descrizione || selectedSport.desc}</span>
                            }
                        </>
                        :
                        <span className="text-md text-cs1">{getLabel('general.choose_sport')}</span>
                    }
                </>
                <i className="bi-caret-down-fill ml-1 text-md text-cs1"></i>
            </div>
            {!props.changeSport &&
                <OpenFavoritesButton />
            }
            {userSettings.showLiveCategories && selectedSport && props.selectedCategory && !conf.iwh &&
                <div className="flex items-center justify-end ml-auto">
                    <CategoriesDropdown categories={selectedSport.categories} selected={props.selectedCategory} changeCategory={props.changeCategory} />
                </div>
            }
            {toggled &&
                <SportsDropdown sports={props.sports}
                                selected={selectedSport}
                                toggle={handleClick}
                                changeSport={props.changeSport}
                                showCalendar={props.showCalendar}
                />
            }
        </div>
    );
}
